import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, Table, Badge, Button } from "reactstrap";
import { Link } from "react-router-dom";
const AlarmPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [alarms, setAlarms] = useState([]);

  useEffect(() => {
    // Mock alarm data (replace with API fetch)
    setAlarms([
      { id: 1, details: "AL: 2F North side corridor-2 AHU Return Air Temp > 27°C", time: "Today, 12:29 PM", criticality: "Critical", occurrence: "||||||", subscribers: "M Y G +2" },
      { id: 2, details: "AL: 2F MR1 1 AHU OFF", time: "Yesterday, 11:35 PM", criticality: "High", occurrence: "||||", subscribers: "M Y G +2" },
      { id: 3, details: "8F Waiting Area 1 AHU Return Air Temp > 27°C", time: "2 Days Ago, 11:05 PM", criticality: "High", occurrence: "||||", subscribers: "M Y G +2" },
      { id: 4, details: "4F ICU 1 area temp=23 & valve position=10", time: "14/07/2024, 10:15 PM", criticality: "Critical", occurrence: "||||||", subscribers: "M Y G +2" },
      { id: 5, details: "Condenser Water Pump 4 is not in Recipe Mode", time: "14/07/2024, 10:15 PM", criticality: "Medium", occurrence: "|||||", subscribers: "M Y G +2" }
    ]);
  }, []);

  const renderBadge = (level) => {
    switch (level) {
      case "Critical":
        return <Badge color="danger">Critical</Badge>;
      case "High":
        return <Badge color="warning">High</Badge>;
      case "Medium":
        return <Badge color="info">Medium</Badge>;
      case "Low":
        return <Badge color="secondary">Low</Badge>;
      default:
        return <Badge color="dark">{level}</Badge>;
    }
  };

  return (
    <React.Fragment>
        <div className="page-content">
    <Container fluid className="p-4 alarm-page">
      <div>
             <div className="em-header-left">
                     <div className="em-ship-info">
                       <span className="em-ship-name">Equipment Overview</span>
                       {/* Vessel Dropdown */}
                     </div>
                     <div className="em-vessel-dropdown-wrapper">
                       <select className="em-vessel-dropdown">
                         <option value="ark-prestige">ARK Prestige</option>
                         <option value="vessel1">Vessel 1</option>
                         <option value="vessel2">Vessel 2</option>
                         <option value="vessel3">Vessel 3</option>
                         <option value="vessel4">Vessel 4</option>
                       </select>
                       <span className="em-vessel-arrow">▾</span>
                     </div>
                   </div>
                     <div className="em-nav">
                                   <button className="em-nb "><Link to="/equip2">Main Engine</Link></button>
                                   <button className="em-nb"><Link to="/auxiliaryEngine1">Auxilary Engine </Link></button>
                                   <button className="em-nb"><Link to="/alerts">Alerts</Link></button>
                                   <button className="em-nb"><Link to="/alarms">Alarms</Link></button>
                                   <button className="em-nb em-nb-active"><Link to="/monitor">Cargo</Link></button>
                                   <button className="em-nb">CCTV</button>
                                   <button className="em-nb">Status</button>
                                   <button className="em-nb">Master</button>
                                   <button className="em-nb">User</button>
                                   <span className="em-badge em-badge-red">10</span>
                                   <span className="em-badge em-badge-yellow">19</span>
                                   <span className="em-ship-sub">UTC : 03:36:16</span>
                                 </div>
                                 </div>
      <Row className="mb-4">
        <Col md={4}>
          <Card className="text-center shadow-sm">
            
            <CardBody>
              <h5>92</h5>
              <p className="text-muted">Active Alerts</p>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center shadow-sm">
            <CardBody>
              <h5>20</h5>
              <p className="text-muted">Unacknowledged Alerts</p>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="text-center shadow-sm">
            <CardBody>
              <h5>10</h5>
              <p className="text-muted">Critical Alerts</p>
            </CardBody>
          </Card>
        </Col>
       
      </Row>

      {/* Tabs */}
      <Nav tabs className="mb-3">
        <NavItem>
          <NavLink
            className={activeTab === "all" ? "active" : ""}
            onClick={() => setActiveTab("all")}
          >
            All
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "active" ? "active" : ""}
            onClick={() => setActiveTab("active")}
          >
            Active
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "resolved" ? "active" : ""}
            onClick={() => setActiveTab("resolved")}
          >
            Resolved
          </NavLink>
        </NavItem>
      </Nav>

      {/* Alarm Table */}
      <Table hover responsive className="table-striped table-bordered">
        <thead className="table-dark">
          <tr>
            <th>Details</th>
            <th>Date & Time</th>
            <th>Criticality</th>
            <th>Occurrence</th>
            <th>Subscribers</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {alarms.map((alarm) => (
            <tr key={alarm.id}>
              <td>{alarm.details}</td>
              <td>{alarm.time}</td>
              <td>{renderBadge(alarm.criticality)}</td>
              <td>{alarm.occurrence}</td>
              <td>{alarm.subscribers}</td>
              <td>
                <Button color="outline-danger" size="sm" className="me-2">
                  🗑
                </Button>
                <Button color="outline-primary" size="sm">
                  👁
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
    </div>
    </React.Fragment>
  );
};

export default AlarmPage;
